"use client";

import { c as _c } from "react/compiler-runtime";
import ClientOnly from "@/components/client-only/ClientOnly";
import { ShareMobileApp } from "@/components/header/share/HeaderShareMobileApps";
import { publicEnv } from "@/config/env";
import { DeepLinkScope } from "@/hooks/useDeepLinkNavigation";
import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import useDeviceInfo from "@/hooks/useDeviceInfo";
export default function OpenMobilePage() {
  const $ = _c(18);
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams?.get("path") || "";
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const pathParam = t0;
  const [decodedPath, setDecodedPath] = useState(null);
  const {
    isAppleMobile
  } = useDeviceInfo();
  let t1;
  let t2;
  if ($[2] !== pathParam) {
    t1 = () => {
      if (typeof window === "undefined" || !pathParam) {
        return;
      }
      const appScheme = publicEnv.MOBILE_APP_SCHEME ?? "mobile6529";
      const decoded = decodeURIComponent(pathParam);
      const deepLink = `${appScheme}://${DeepLinkScope.NAVIGATE}${decoded}`;
      setDecodedPath(decoded);
      window.location.href = deepLink;
    };
    t2 = [pathParam];
    $[2] = pathParam;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== decodedPath) {
    t3 = () => {
      if (decodedPath) {
        window.location.href = `${window.location.origin}${decodedPath}`;
      } else {
        window.location.href = window.location.origin;
      }
    };
    $[5] = decodedPath;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleBack = t3;
  let t4;
  if ($[7] !== isAppleMobile) {
    t4 = () => {
      const shareIos = <ShareMobileApp platform="ios" target="_self" />;
      const shareAndroid = <ShareMobileApp platform="android" target="_self" />;
      const userAgent = typeof navigator === "undefined" ? "" : navigator.userAgent;
      const isAndroid = /android/i.test(userAgent);
      if (isAppleMobile) {
        return shareIos;
      } else {
        if (isAndroid) {
          return shareAndroid;
        }
      }
      return <>{shareIos}{shareAndroid}</>;
    };
    $[7] = isAppleMobile;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const printShareMobileApps = t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className="tw-text-2xl tw-font-bold tw-animate-pulse">Opening 6529 Mobile...</p>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="tw-text-xl tw-font-bold">Get 6529 Mobile</p>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== printShareMobileApps) {
    t7 = <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1">{t6}<div className="tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-4">{printShareMobileApps()}</div></div>;
    $[11] = printShareMobileApps;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== handleBack) {
    t8 = <button onClick={handleBack} className="tw-mt-10 btn-link">Back to 6529.io</button>;
    $[13] = handleBack;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <ClientOnly><div className="tailwind-scope tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-screen tw-text-center tw-p-4 tw-gap-10">{t5}{t7}{t8}</div></ClientOnly>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}